module.exports = __webpack_public_path__ + "static/img/goodness.7a04ab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/goodness.png
// module id = 5sS/
// module chunks = 1